module.exports = Em.Handlebars.compile("{{#if isSelectable}}\n    {{input type=\"checkbox\" checkedBinding=\"checked\"}}\n{{/if}}");